import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class AssignmentsService {
  constructor(private http: HttpClient) {}

  public GetAssignments(bookingId) {
    let targetUrl = `${environment.api_base}/private/assignments/get_assignments?booking_id=${bookingId}`;
    return this.http.get<any>(targetUrl);
  }

  public Add(data: FormData) {
    let targetUrl = `${environment.api_base}/private/assignments/add`;
    return this.http.post<any>(targetUrl, data);
  }

  public updateAssignmentStatus(id, status) {
    let targetUrl = `${environment.api_base}/private/assignments/change_status?assignment_id=${id}&status=${status}`;
    return this.http.get<any>(targetUrl);
  }

  public getAppointmentById(id) {
    let targetUrl = `${environment.api_base}Appointment/${id}`;
    return this.http.get<any>(targetUrl);
  }

  public getCoachAppointmentById(id) {
    let targetUrl = `${environment.api_base}Coach/Appointment/${id}`;
    return this.http.get<any>(targetUrl);
  }

  getSharedAutoLookup = (id) => { 
    let targetUrl = `${environment.api_base}Shared/AutoLookup?type=${id}`;
    return this.http.get<any>(targetUrl);
  }
  
}
